import { combineReducers } from 'redux'
import server from './ServerReducer'
import authentication from './authenticationReducer'
import app from './appReducer'

export default combineReducers({ 
    server,
    authentication,
    app
});
